const CURRENT_TIME = new Date().getTime();
// one day time in ms
const ONE_DAY = 1000 * 3600 * 24;
export const filterByDate = (pages) => pages.filter(({ lastUpdated }) => {
    const previousTime = new Date(lastUpdated).getTime();
    const differenceInDays = (CURRENT_TIME - previousTime) / ONE_DAY;
    // images updated in less than ~2 weeks ago (14/15 days)
    return differenceInDays < 15;
});
